/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface BlockquoteBlockDataContent
 */
export interface BlockquoteBlockDataContent {
  /**
   *
   * @type {string}
   * @memberof BlockquoteBlockDataContent
   */
  text?: string
  /**
   *
   * @type {string}
   * @memberof BlockquoteBlockDataContent
   */
  subText?: string
}

/**
 * Check if a given object implements the BlockquoteBlockDataContent interface.
 */
export function instanceOfBlockquoteBlockDataContent(
  value: object
): value is BlockquoteBlockDataContent {
  return true
}

export function BlockquoteBlockDataContentFromJSON(
  json: any
): BlockquoteBlockDataContent {
  return BlockquoteBlockDataContentFromJSONTyped(json, false)
}

export function BlockquoteBlockDataContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BlockquoteBlockDataContent {
  if (json == null) {
    return json
  }
  return {
    text: json['text'] == null ? undefined : json['text'],
    subText: json['subText'] == null ? undefined : json['subText'],
  }
}

export function BlockquoteBlockDataContentToJSON(
  value?: BlockquoteBlockDataContent | null
): any {
  if (value == null) {
    return value
  }
  return {
    text: value['text'],
    subText: value['subText'],
  }
}
